import React from 'react';
import PropTypes from 'prop-types';
import { useUiV2 } from '../../config/uiVersion';
import { Button } from '../ui';
import '../AppShell/chromeStates.css';

const Icon = () => (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M15 9l-6 6M9 9l6 6" />
    </svg>
);

const TITLE = 'No access to IronSight';
const BODY = 'Your account doesn’t have access to IronSight, or it has been removed or suspended. Please contact your administrator.';

// Today's card, pixel for pixel (the new design flag off).
function AccessDeniedV1({ onSignOut }) {
    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f8f6', fontFamily: 'Inter, system-ui, sans-serif', padding: '2rem' }}>
            <div style={{ maxWidth: 420, textAlign: 'center', background: '#fff', border: '1px solid #e7e9e3', borderRadius: 16, padding: '2.4rem', boxShadow: '0 14px 40px rgba(16,32,15,.1)' }}>
                <div style={{ width: 52, height: 52, margin: '0 auto 1.1rem', borderRadius: '50%', background: '#fbe4e4', color: '#b91c1c', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Icon />
                </div>
                <h1 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#16200f', margin: '0 0 .5rem' }}>{TITLE}</h1>
                <p style={{ fontSize: '.95rem', color: '#6b7563', lineHeight: 1.5, margin: '0 0 1.6rem' }}>{BODY}</p>
                <button type="button" onClick={onSignOut} style={{ fontFamily: 'inherit', fontWeight: 600, fontSize: '.95rem', cursor: 'pointer', color: '#fff', background: '#689F38', border: 'none', borderRadius: 10, padding: '.75rem 1.4rem' }}>Sign out</button>
            </div>
        </div>
    );
}
AccessDeniedV1.propTypes = { onSignOut: PropTypes.func.isRequired };

/**
 * Shown when an authenticated Entra user has no valid IronSight identity
 * (removed, suspended, no access): /me answered 403, or a data route did
 * later (`pp:access-revoked`). Same copy and Sign out in both designs.
 */
export default function AccessDenied({ onSignOut }) {
    const uiV2 = useUiV2();
    if (!uiV2) return <AccessDeniedV1 onSignOut={onSignOut} />;
    return (
        <div className="v2-denied-page">
            <div className="v2-denied" role="alert">
                <div className="v2-denied-ic"><Icon /></div>
                <h1>{TITLE}</h1>
                <p>{BODY}</p>
                <Button variant="primary" onClick={onSignOut}>Sign out</Button>
            </div>
        </div>
    );
}
AccessDenied.propTypes = { onSignOut: PropTypes.func.isRequired };
